import * as React from 'react';
import { useObjCommonFilterStore } from '../../hooks/objCommonFilter';

const ObjCommonFilterSelection = (props) => {

  const [{ filter_list }, {}, { clear_filter_by_key, clear_all_filter, clear_array_value }] = useObjCommonFilterStore();

  return (
    <>
      {filter_list && Object.entries(filter_list).length > 0 &&
        <div className="applied-filters-wrapper mt-3">
          <div className="applied-filters border-1">
            <span className="applied-filters-inner">
              <div className="filter-controls">
                <div><strong>Filters</strong></div>
                <button className="bs5 btn btn-white btn-secondary ms-auto filter-brdcrumb-clear"
                        data-di-id="di-id-3a31eb8d-378bc1a3"
                        onClick={() => clear_all_filter()}>
                  Clear All
                </button>
              </div>
              <div className="filters-breadcrumb">
                {Object.keys(filter_list).map((v, i) => (
                  <div key={i} className="filter-group">
                    <div name="categoryId" className="filter-group-title">
                      <span tabIndex={-1} className="filter-name noSelect">{filter_list[v]?.searchType}</span>
                      <button className="remove-filter-group" onClick={() => clear_filter_by_key(v)}>
                        <i className="fa fa-times"></i>
                        <span className="sr-only">Remove Filter</span>
                      </button>
                    </div>
                    <div className="group-filters">
                      <div className="group-filter-item">
                        {filter_list[v]?.searchKeyword ?
                          <span className="button-white button-small">
                            <span tabIndex={-1}
                                  className="filter-item">{filter_list[v].searchKeyword}</span>
                            <a href={void (0)} onClick={() => clear_filter_by_key(v)}>
                              <i className="fa fa-times"></i>
                              <span className="sr-only">Remove Filter</span>
                            </a>
                          </span>
                          : <>
                            {filter_list[v]?.searchKeywordArr && filter_list[v].searchKeywordArr?.length > 0 &&
                              filter_list[v].searchKeywordArr.map((ele) => (
                                <span className="button-white button-small" key={ele?.value}>
                                  <span className="filter-item"> {ele?.label} </span>
                                  <a href={void (0)}
                                     onClick={() => clear_array_value({ data: { key: v, value: ele?.value } })}>
                                    <i className="fa fa-times"></i>
                                    <span className="sr-only">Remove Filter</span>
                                  </a>
                                </span>
                              ))
                            }
                          </>
                        }
                      </div>
                    </div>
                  </div>
                ))
                }
              </div>
            </span>
          </div>
        </div>
      }
    </>
  );
}

export default ObjCommonFilterSelection;